import {t} from "../../../i18n";
import {Modal} from "react-bootstrap";
import {useDispatch} from "react-redux";
import Title from "../../../layout/Title";
import {useEffect, useState} from "react";
import {Spinner} from "../../../ui/Spinner";
import {LoginStatus} from "../../../http/Types";
import {getContainer} from "../../../ioc/IOCSetup";
import {BrandButton} from "../../../ui/buttons/buttons";
import {ModalProps, PATH} from "../UserModalController";
import {isRedirectToVerifyPrincipal} from "../../../user/ui/utils";
import {fetchInfoPage} from "../../../contenful/ContentfulActions";
import {termsAccepted, termsDeclined} from "../../../user/UserActions";
import {richTextOptions} from "../../../ui/InfoPageAccordionComponent";
import DynamicContentView from "../../../landingpage/pagesection/DynamicContentView";
import {isHomeScreen, setModalPath} from "../utils";
import {renderContentAsComponent} from "../../../contentutils";
import {InfoPage} from "../../../contenful/types";

const TermsAndConditionModal = ({ ...rest }: Partial<ModalProps>) => {
  const { history, user, location } = rest;
  const dispatch = useDispatch();
  const homeScreen = isHomeScreen();
  const [terms, setTerms] = useState<any>(undefined);
  const [termsLoading, setTermsLoading] = useState<boolean>(true);

  //only keeping this not to break unit tests
  const [contentful] = useState(()=>{
    try {
      return getContainer().getContentfulClientService();
    } catch (_) {
      return undefined
    }
  })

  const declineTerms = () => {
    dispatch(termsDeclined());
  };

  const acceptTerms = () => {
    dispatch(termsAccepted() as any);
  };

  // get terms, defualt language english
  useEffect(() => {

    if(contentful) {
      let lng = getContainer().getSettingsService().getActiveLocale().code;
      fetchInfoPage("terms", "en")
          .then((e: InfoPage[]) => {
            setTerms(e[0]);
            setTermsLoading(false);
          })
          .catch((e: any) => {
            console.error("Unable to find page");
            // Error being catch in ModalBoundary
            throw new Error ("Unable to find page")
          });
    }


  }, [dispatch]);

   useEffect(() => {
    const cardBodyClass = document.querySelectorAll<HTMLElement>(
      ".expandable-accordion"
    );
    const arrow = document.querySelectorAll<HTMLElement>(".arrow-accordion");
    for (var i = 0; i < cardBodyClass.length; i++) {
      cardBodyClass[i].style.height = "0px";
      cardBodyClass[i].style.visibility = "hidden";
      cardBodyClass[i].style.maxHeight = "0px";
      cardBodyClass[i].classList.remove("expanded");
    }
    for (var i = 0; i < arrow.length; i++) {
      arrow[i].classList.remove("show");
    }
  });

  // Redirect to right modal based on auth proccess.
  const userStatus = user && user.status;
  const verifyEmailStatus = user && user.verifyEmailStatus;
  const userProgress = user && user.status === LoginStatus.IN_PROGRESS;

  useEffect(() => {
    if (history && location) {
      if (isRedirectToVerifyPrincipal(userStatus, verifyEmailStatus)) {
        if (location.search.includes(PATH.NEW_USER)) {
          setModalPath({ path: { type: PATH.VERIFY_EMAIL, modal: PATH.NEW_USER,}, history });
        } else {
          setModalPath({ path: { type: PATH.VERIFY_EMAIL, modal: PATH.MODAL_TYPE }, history });

        }
      }
      if (userStatus !== LoginStatus.ACCEPT_TERMS_REQUIRED) {
        if (location.search.includes(PATH.NEW_USER)) {
          setModalPath({ path: { type: PATH.REGISTER_SUCCESS, modal: PATH.MODAL_TYPE }, history });
        } else {
          if(!isRedirectToVerifyPrincipal(userStatus, verifyEmailStatus)){
            setModalPath({ path: undefined, history }); 
          } 
        }
      }
    }
  }, [user]); 

  const newUser = location && location.search.includes(PATH.NEW_USER);

  const LoadingSpinner = <div id="sc" data-testid={PATH.TERMS_CONDITION}><Spinner /></div>

  if (termsLoading) {
    return LoadingSpinner;
  }

  return (
    <div className={`modal-wrapper ${PATH.TERMS_CONDITION} ${!homeScreen ? "active" : null}`}>
      {!newUser && (
        <Modal.Header>
          <Title animate={true} title={t("acceptTermsPage.title")} subtitle={t("acceptTermsPage.subtitle")}/>
        </Modal.Header>
      )}
      {!termsLoading && <Modal.Body>
        <div className="modal-infoPageView terms">
          <div className="modal-infoPage-container-outer">
            <div className="modal-infoPage-container">
              {renderContentAsComponent(terms.body as any, richTextOptions)}
            </div>
            <div className={`modal-infoAccordion`}>
              <DynamicContentView dynamicContent={terms.dynamicContent} infoPageId={terms.id} loggedIn={false}/>
            </div>
          </div>
        </div>
      </Modal.Body>}
      <Modal.Footer>
        <BrandButton type={"button"} loading={userProgress} className={"btn btn-secondary xfull-width"} onClick={declineTerms}>
          {t("acceptTermsPage.button.decline")}
        </BrandButton>
        <BrandButton type={"submit"} loading={userProgress} className={"btn btn-cta xfull-width"} onClick={acceptTerms} >
          {t("acceptTermsPage.button.accept")}
        </BrandButton>
      </Modal.Footer>
    </div>
  );
};

export default TermsAndConditionModal;
